var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16034_8705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.8246 0.000340462H0V61.734H60.8246V0.000340462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.04883 4.50535V57.231H56.7745V4.50535H4.04883ZM55.3696 55.8261H5.45374V5.91027H55.3696V55.8261Z",
    fill: "#818485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6016 42.5218H14.2957C14.6263 42.5218 14.9155 42.5631 15.2461 42.6871C15.5767 42.811 15.8659 42.935 16.1139 43.1829C16.3618 43.3895 16.5684 43.6788 16.7337 43.968C16.899 44.2986 16.9816 44.6705 16.9816 45.0837C16.9816 45.4969 16.899 45.8688 16.7337 46.1994C16.5684 46.5299 16.3618 46.7779 16.1139 46.9845C15.8659 47.1911 15.5767 47.3564 15.2461 47.4803C14.9155 47.6043 14.6263 47.6456 14.2957 47.6456H12.6016V42.5218ZM13.1387 47.1911H14.1718C14.5437 47.1911 14.8742 47.1497 15.1635 47.0258C15.4527 46.9018 15.7006 46.7365 15.8659 46.5712C16.0725 46.3646 16.1965 46.158 16.2791 45.9101C16.3618 45.6622 16.4031 45.4143 16.4031 45.125C16.4031 44.8771 16.3618 44.5878 16.2791 44.3399C16.1965 44.092 16.0312 43.8854 15.8659 43.6788C15.6593 43.4722 15.4527 43.3069 15.1635 43.2242C14.8742 43.1003 14.5437 43.059 14.1718 43.059H13.1387V47.1911Z",
    fill: "#005586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2462 47.1911H22.9733V47.6456H19.709V42.5218H22.8907V42.9763H20.2462V44.7118H22.7254V45.1663H20.2462V47.1911Z",
    fill: "#005586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2945 46.9036V42.5648H29.8316V47.6887H29.1705L26.1954 43.3086V47.6887H25.6582V42.5648H26.3193L29.2945 46.9036Z",
    fill: "#005586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4599 47.6456H33.9227V42.9763H32.2285V42.5218H36.154V42.9763H34.4599V47.6456Z",
    fill: "#005586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5528 47.6456H38.0156L40.2056 42.5218H40.7015L42.8915 47.6456H42.313L41.7345 46.3233H39.09L38.5528 47.6456ZM39.3379 45.8275H41.5692L40.4536 43.1003L39.3379 45.8275Z",
    fill: "#005586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.824 47.1911H48.2206V47.6456H45.3281V42.5218H45.8653V47.1911H45.824Z",
    fill: "#005586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3457 35.3325V36.4894H42.0637V38.5555H52.4766V35.3325H8.3457Z",
    fill: "#8C8E8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5586 14.0943V21.2015H34.2531V14.0943H29.4598L24.6666 26.5732L19.9146 14.0943H15.0801V31.9037H18.0965V17.1107H18.1792L23.5509 31.9037H25.7822L31.0713 17.3586V31.9037H31.2366H34.2531V24.0527H42.5586V31.9037H45.7403V14.0943H42.5586Z",
    fill: "#005586"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16034_8705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.8246,
    height: 61.7337,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/login-logo.006b1b2588636e99ec23fa6bf9bb26b7.svg";
export { ForwardRef as ReactComponent };